import ApprovedTires from 'pages/CatalogPage/DH/Tires/ApprovedTires/ApprovedTires';

export default ApprovedTires;
